export default "__VITE_ASSET__YX6$NSe6Is5DaOJZGqVRkQ__"